import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import SettingsSubPageShell from '../../components/settings/SettingsSubPageShell';
import { useTranslation } from '../../i18n/LocaleContext';

function RowChevron() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M9 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function EmailIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M3 7l9 7 9-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="18" r="1" fill="currentColor" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <rect x="10" y="10" width="4" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export default function SecurityCenterPage() {
  const { t } = useTranslation();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    memberApi
      .getInfo()
      .then((info) => {
        if (!cancelled) {
          setMember(info || null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setMember(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const emailStatus = member?.email?.trim()
    ? member.email.trim()
    : t('security.notBound');
  const phoneStatus = member?.mobile?.trim()
    ? member.mobile.trim()
    : t('security.notBound');

  return (
    <SettingsSubPageShell title={t('security.title')}>
      {loading && <p className="security-page__status">{t('common.loading')}</p>}

      <div className="security-card">
        <div className="security-row security-row--static">
          <span className="security-row__icon" aria-hidden><EmailIcon /></span>
          <span className="security-row__label">{t('security.email')}</span>
          <span className="security-row__value">{emailStatus}</span>
        </div>

        <div className="security-row security-row--static">
          <span className="security-row__icon" aria-hidden><PhoneIcon /></span>
          <span className="security-row__label">{t('security.phone')}</span>
          <span className="security-row__value">{phoneStatus}</span>
        </div>

        <Link
          to="/security/withdraw-password"
          className="security-row security-row--link"
        >
          <span className="security-row__icon" aria-hidden><ShieldIcon /></span>
          <span className="security-row__label">{t('security.withdrawPassword')}</span>
          <span className="security-row__value">
            {member?.hasJyPassword ? t('security.modify') : t('security.goSet')}
            <RowChevron />
          </span>
        </Link>

        <Link
          to="/security/login-password"
          className="security-row security-row--link security-row--last"
        >
          <span className="security-row__icon" aria-hidden><ShieldIcon /></span>
          <span className="security-row__label">{t('security.loginPassword')}</span>
          <span className="security-row__value">
            {t('security.modify')}
            <RowChevron />
          </span>
        </Link>
      </div>
    </SettingsSubPageShell>
  );
}
